<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <ok-logo />
        </b-link>
        <error-alert
          v-if="error"
          :error="error"
        />
        <b-card-title class="mb-1">
          {{ $t('auth.forgot-pass') }} 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          {{ $t('auth.forgot-hint') }}
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="simpleRules"
          #default="{invalid}"
        >
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <ok-text-input
              v-model="userEmail"
              :label="$t('fields.email')"
              rules="email"
              dir="ltr"
              input-class="text-left"
              :is-required="true"
            />
            <template v-if="showReset">
              <ok-text-input
                v-model="code"
                :label="$t('auth.code')"
                :is-required="true"
              />
              <!-- password -->
              <b-form-group
                label="New Password"
                label-for="reset-password-new"
                class="auth-label"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required|min:6|max:50"
                >
                  <password-input
                    v-model="password"
                    :label="$t('auth.new-password')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                label="Confirm Password"
                class="auth-label"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:Password"
                >
                  <password-input
                    v-model="cPassword"
                    :label="$t('auth.password-confirm')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </template>
            <!-- submit button -->
            <b-button
              variant="primary"
              block
              :disabled="invalid || submitting"
              type="submit"
            >
              {{ $t(showReset?'forms.submit':'auth.send-reset') }}
              <b-spinner
                v-if="submitting"
                small
                class="mr-50"
              />
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{name:'login'}">
            <feather-icon icon="ChevronLeftIcon" /> {{ $t('auth.back-login') }}
          </b-link>
        </b-card-text>

      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BCard, BLink, BCardText, BCardTitle, BForm, BButton, BSpinner, BFormGroup,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import OkLogo from '@/@okmenu/icons/OkLogo'
import OkTextInput from '@/@okmenu/components/inputs/OkTextInput'
import AuthApis from '@/API/auth-api'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import PasswordInput from '@/@okmenu/components/inputs/PasswordInput'

export default {
  components: {
    PasswordInput,
    ErrorAlert,
    OkTextInput,
    OkLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BButton,
    BForm,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      userEmail: '',
      error: null,
      cPassword: '',
      password: '',
      code: '',
      submitting: false,
      showReset: false,
      required,
      email,
    }
  },
  methods: {
    async validationForm() {
      this.error = null
      const valid = this.$refs.simpleRules.validate()
      if (valid) {
        this.submitting = true
        if (this.showReset) {
          await AuthApis.reset({ email: this.userEmail, code: this.code, password: this.password }).then(res => {
            if (res.response === 201) {
              this.$notifySuccess(res.message)
              this.$router.replace({ name: 'login' }).catch(() => {})
            } else {
              this.$notifyError(res.message)
              this.submitting = false
            }
          }).catch(e => {
            this.error = e
            this.submitting = false
          })
        } else {
          await AuthApis.forgot(this.userEmail).then(res => {
            if (res.response === 201) {
              this.$notifySuccess(res.message)
              this.showReset = true
            } else this.$notifyError(res.message)
          }).catch(e => { this.error = e })
            .finally(() => { this.submitting = false })
        }
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('auth.forgot-pass'),
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
